import { AutoExportFormatterType } from './autoexport-formatter-type.model';

export class AutoExportFormatterTypeItem {
    constructor(formatterType: AutoExportFormatterType, formatterTypeText: string) {
        this.formatterType = formatterType;
        this.formatterTypeText = formatterTypeText;
    }

    formatterType: AutoExportFormatterType;
    formatterTypeText: string;
}
